import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
var _excluded = ["product_type", "price", "amount", "groupid"];
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import Protocol from './protocol';
import { invoke } from './lib/tenvideo';
import { assign } from './util';
var STATUS_PURCHASE_SUCCESS = 'PurchaseSuccess';
var STATUS_PURCHASE_CANCEL = 'PurchaseCancel';
var CODE_PURCHASE_CANCEL = 12;
var CODE_PURCHASE_UNKNOWN = -1;
var CODE_PURCHASE_SUCCESS = 6;
/**
 * iPad 客户端 JSBridge 接口
 * @extends Protocol
 */

var IpadJSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(IpadJSBridge, _Protocol);

  var _super = _createSuper(IpadJSBridge);

  function IpadJSBridge() {
    var _this;

    _classCallCheck(this, IpadJSBridge);

    _this = _super.call(this);
    _this.name = 'IpadJSBridge';
    _this.EVENTS.pay = 'PurchaseStatusCallback';
    return _this;
  }
  /**
   * 退出登录，低版本显示双登录弹窗
   * @version 5.4.0
   * @return Promise
   */


  _createClass(IpadJSBridge, [{
    key: "logout",
    value: function logout() {
      var _this2 = this;

      return this.checkApi(['openLogoutView']).then(function (check) {
        if (check.openLogoutView) {
          return invoke('openLogoutView');
        }

        return _this2.openLogin();
      });
    }
    /**
     * 拉起客户端支付
     * @param [options] {Object} - Pay options
     * @param [options.aid] {String} - 根据特定规则拼接的 aid 字符串，用于平台、版本号等
     * @param [options.ap] {Number} - 未知什么意思
     * @param [options.id] {Number} - 商品 id，支付的关键参数
     * @param [options.amount] {Number} - 购买数量
     * @param [options.price] {Number} - 商品价格
     * @param [options.product_type] {Number} - 商品类型：month, day
     * @returns {Promise} A Promise that returns an Object if resolved
     * @example <caption>Pass product options to client pay.</caption>
     * atom.openPay({
     *     "aid": "V0$$2:5$4:3$1:0$11:3$3:5.4.0.2017$8:4",
     *     "ap": 0,
     *     "id": "com.tenvideoios.OneMonthPay1",
     *     "amount": "1",
     *     "price": "25",
     *     "product_type": "month"
     * })
     */
    // eslint-disable-next-line

  }, {
    key: "openPay",
    value: function openPay() {
      var _this3 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          product_type = _ref.product_type,
          price = _ref.price,
          amount = _ref.amount,
          groupid = _ref.groupid,
          params = _objectWithoutProperties(_ref, _excluded);

      var apiName;
      assign(params, {
        price: price,
        product_price: price,
        monthgroup: groupid ? encodeURIComponent("group_id=".concat(groupid)) : ''
      }); // eslint-disable-next-line

      if (product_type === 'day') {
        apiName = 'openPayByDay';
        assign(params, {
          day: amount
        });
      } else {
        apiName = 'openPay';
        assign(params, {
          month: amount
        });
      }

      invoke('PurchaseStatus');
      invoke(apiName, params);
      return new Promise(function (resolve) {
        _this3.once(_this3.EVENTS.pay, function (r) {
          if (r && r.result && r.result.state === STATUS_PURCHASE_SUCCESS) {
            resolve(_objectSpread(_objectSpread({}, r), {}, {
              paySucc: 1,
              payStatus: CODE_PURCHASE_SUCCESS
            }));
          } else {
            resolve(_objectSpread(_objectSpread({}, r), {}, {
              paySucc: 0,
              payStatus: r && r.result && r.result.state === STATUS_PURCHASE_CANCEL ? CODE_PURCHASE_CANCEL : CODE_PURCHASE_UNKNOWN
            }));
          }
        });
      });
    }
    /**
     * 切换内部协议相关的方法
     * @param {any} url - txvideo 内部协议链接
     * @returns {Promise}
     * @example
     * atom.doAction('txvideo://v.qq.com/HomeActivity?tabName=VipTab&channelId=100203')
     */

  }, {
    key: "doAction",
    value: function doAction(url) {
      return invoke('doAction', {
        url: url
      });
    }
    /**
     * 拉起双登录，引导用户登录后进行下一步购买
     * 1. 越狱或绕iap，未登录点击普通包月套餐，期望引导用户登录，登陆回来之后直接进行下一步支付，即拉起h5扫码浮层。
     * 2. 非审核期间，未登录点击连续包月或连续包季套餐，期望引导用户登录，登陆回来之后继续查询当前登录态是否订阅过连续包月或连续包季套餐，
     * 弹窗提示（未订阅的话弹窗提示一个appid只能为一个帐号订阅，已订阅的话提示已订阅），未订阅且用户点击继续开通，再调用openpay。在这两个场景下会调用这个登录接口。
     * @version 5.4.0
     * @returns {Promise}
     */

  }, {
    key: "loginAlert",
    value: function loginAlert() {
      return invoke('loginAlert');
    }
    /**
     * 复制内容到剪贴版
     * @param {String} content - 需要复制的内容文本
     */

  }, {
    key: "copyToClipBoard",
    value: function copyToClipBoard(content) {
      return invoke('copyToClipBoard', {
        content: content
      });
    }
    /**
     * 打开第三方app
     * @param {String} pkgName - bundle 名
     * @returns {Promise} A promise when app is not installed, will reject
     * errCode 1
     */

  }, {
    key: "launch3rdApp",
    value: function launch3rdApp() {
      var pkgName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return invoke('launch3rdApp', {
        pkgName: pkgName
      });
    }
    /**
     * 获取第三方应用是否已安装
     * @param {String} pkgName - bundle 名
     * @returns {Promise} A promise resolve an Object `{ installed: true }`
     */

  }, {
    key: "isInstalled",
    value: function isInstalled() {
      var pkgName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return invoke('isInstalled', {
        pkgName: pkgName
      });
    }
    /**
     * 设置分享的相关内容，调用后将会在右上角显示分享入口
     * @param {Object} options - 分享相关配置
     * @version 5.3.0
     * @returns {Promise}
     * @example
     * atom.setMoreInfo({
     *    "shareInfo": {
     *        "url": "https://v.qq.com",
     *        "title": "主标题",
     *        "subTitle": "副标题",
     *        "singleTitle": "朋友圈标题",
     *        "imageUrl": "https://xxx.jpg"
     *    }
     * })
     */

  }, {
    key: "setMoreInfo",
    value: function setMoreInfo() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('setMoreInfo', _objectSpread({
        hasRefresh: true,
        hasShare: true,
        hasFollow: true
      }, options));
    }
    /**
     * 打开分享面板
     * @param {Object} options - 分享内容配置
     * @returns {Promise}
     * @example
     * atom.openToolsDialog({
     *     "webShareID": "23333",
     *     "webShareTitle": "This`s Title",
     *     "webShareSubTitle": "This`s SubTitle",
     *     "webShareImageURL": "https://xxx.jpg",
     *     "webShareURL": "https://v.qq.com",
     *     "useCustomeInfo": true
     * })
     */

  }, {
    key: "openToolsDialog",
    value: function openToolsDialog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('shareTo', options);
    }
    /**
     * 拉起第三方应用
     * @param {String} pkgName 应用的包名
     * @returns {Boolean} 是否已安装应用
     */

  }, {
    key: "launch",
    value: function launch() {
      var pkgName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return invoke('isInstalled', {
        pkgName: pkgName
      }).then(function (_ref2) {
        var _ref2$installed = _ref2.installed,
            installed = _ref2$installed === void 0 ? false : _ref2$installed;

        if (installed) {
          invoke('launch3rdApp', {
            pkgName: pkgName
          });
          return true;
        }

        return false;
      });
    }
    /**
     * native 页面跳转操作
     * @param {string} url - txvideo://v.qq.com/ 协议地址
     * @param options {Object} - 其它参数值
     * @param options.type {String} - default|pop，当 url 值为 http 地址时，可指定 type=pop 参数，以弹窗形式打开 webview
     * @example <caption>iPad 示例</caption>
     * atom.openView('txvideo://v.qq.com/HomeActivity?tabName=VipTab&channelId=100203')
     * @example <caption>弹窗形式打开 webview</caption>
     * atom.openView('https://film.qq.com/ipad/upay', { type: 'pop' })
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          type = _ref3.type;

      if (url.match(/^(https?:)?\/\//)) {
        var activityType = 'Html5Activity';

        if (type === 'pop') {
          activityType = 'PopHollywoodH5Activity';
        } else if (url.match(/\.qq\.com/)) {
          activityType = 'HollywoodH5Activity';
        }

        url = "txvideo://v.qq.com/".concat(activityType, "?url=").concat(encodeURIComponent(url));
      }

      if (!url.match(/^(txvideo|tenvideo2|qqlive)/)) {
        return this.toast('非法 Url 地址！');
      }

      invoke('openView', {
        url: url
      });
    }
    /**
     * 下载App
     * @param options {Object} - 下载参数
     * @param options.downloadUrl {String} - 注对 iOS : downloadUrl packageName channel 非必填
     * @param options.itunesUrl {String} - 苹果安装包地址
     * @author colynchen
     * @returns {Promise}
     */

  }, {
    key: "download3rdApp",
    value: function download3rdApp() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('download3rdApp', options);
    }
  }]);

  return IpadJSBridge;
}(Protocol);

export default new IpadJSBridge();